import React, { useEffect, useState } from 'react';

import DashboardCard from './dashboardCard';
import Loading from '../../loading';
import MarketError from '../components/marketError';
import SummaryCardGrid from '../components/summaryCardGrid';
import { getDaysBetween } from '../../../utilities/dateHelpers';
import SummaryCard from '../components/summaryCard';
import SoldHomesChart from '../components/soldHomesChart';
import PreSalesChart from '../components/preSalesChart';
import AvgDaysOnMarketChart from '../components/avgDaysOnMarketChart';
import ChartContainer from '../components/chartContainer';
import { average, shallowEqual } from '../../../utilities/generalHelpers';
import useGetSoldHomes from '../hooks/useGetSoldHomes';
import RealEstateMarketDateFilters from './realEstateMarketDateFilters';

const SoldHomesCard = ({ filters, onChange }) => {
    const [summaryData, setSummaryData] = useState();
    const [lastSearch, setLastSearch] = useState();
    const { doSearch, marketLoading, marketData, apiError } = useGetSoldHomes();

    useEffect(() => {
        if (!lastSearch || !shallowEqual(lastSearch, filters)) {
            doSearch(filters);
            setLastSearch(filters);
        }
    }, [filters]);

    useEffect(() => {
        if (marketData.length) {
            let daysOnMarket = [];
            let numberPreSales = 0;
            marketData.forEach((listing) => {
                const days = getDaysBetween(
                    listing['mls_history.listing_date'],
                    listing['mls_history.sold_date'],
                );
                if (days <= 0) {
                    ++numberPreSales;
                }
                daysOnMarket.push(days);
            });
            const summary = {
                homesSold: marketData.length,
                avgDaysOnMarket: average(daysOnMarket),
                numberPreSales,
            };
            setSummaryData(summary);
        }
    }, [marketData]);

    const handleRetry = () => doSearch(filters);

    return (
        <DashboardCard title="Sold Homes">
            <RealEstateMarketDateFilters filters={filters} onChange={onChange} />
            {apiError ? (
                <MarketError onRetry={handleRetry} />
            ) : (
                <div className="d-flex justify-content-center align-items-center">
                    {marketLoading || !summaryData ? (
                        <Loading />
                    ) : marketData.length === 0 ? (
                        <p>No data returned!</p>
                    ) : (
                        <div className="w-100 mb-2">
                            <SummaryCardGrid>
                                <SummaryCard
                                    title="AVG Days on Market"
                                    value={`${Number(summaryData.avgDaysOnMarket).toFixed(0)} Days`}
                                />
                                <SummaryCard
                                    title="Number Homes Sold"
                                    value={summaryData.homesSold}
                                />
                                <SummaryCard
                                    title="Number of Pre-Sales"
                                    value={summaryData.numberPreSales}
                                />
                            </SummaryCardGrid>
                            <div className="realEstateChartsGrid">
                                <ChartContainer title="AVG Days on Market">
                                    <AvgDaysOnMarketChart
                                        marketData={marketData}
                                        searchOptions={filters}
                                    />
                                </ChartContainer>
                                <ChartContainer title="Number of Homes Sold">
                                    <SoldHomesChart
                                        marketData={marketData}
                                        searchOptions={filters}
                                    />
                                </ChartContainer>
                                <ChartContainer title="Number of Pre-Sales">
                                    <PreSalesChart
                                        marketData={marketData}
                                        searchOptions={filters}
                                    />
                                </ChartContainer>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </DashboardCard>
    );
};

export default SoldHomesCard;
